document.addEventListener('DOMContentLoaded', () => {
  // Error page title animation
  function initErrorPageTitleAnimation() {
    const dynamicTitle = document.querySelector('.error-page__dynamic-title');
    if (dynamicTitle) {
      const container = dynamicTitle.querySelector('.error-page__dynamic-title-wrapper');
      const items = container.children;
      const wordCount = items.length;

      if (wordCount > 1) {
        const firstClone = items[0].cloneNode(true);
        container.appendChild(firstClone);

        let index = 0;
        const itemHeight = items[0].offsetHeight;
        const slideDuration = 800;
        const pauseDuration = 1500;

        function slideToNext() {
          index++;
          container.classList.add('slide');
          container.style.transform = `translateY(-${index * itemHeight}px)`;

          if (index === wordCount) {
            setTimeout(() => {
              container.classList.remove('slide');
              container.style.transform = 'translateY(0)';
              index = 0;
            }, slideDuration);
          }
        }

        setInterval(slideToNext, slideDuration + pauseDuration);
      }
    }
  }

  //Logo wall animation
  function initLogoWall() {
    const wrappers = document.querySelectorAll('.logos-wrapper');
    if (!wrappers.length) return;

    wrappers.forEach((wrapper) => {
    const isFrontpageHero = wrapper.classList.contains('hero-frontpage');
    const screenWidth = window.innerWidth;
    const logosPerRow = isFrontpageHero && screenWidth < 768 ? 3 : 6;


    const allLogos = Array.from(wrapper.querySelectorAll('img'));
    if (allLogos.length <= logosPerRow) return;

    wrapper.innerHTML = '';

    // Split into groups of logos
    for (let i = 0; i < allLogos.length; i += logosPerRow) {
      const group = allLogos.slice(i, i + logosPerRow);
      const row = document.createElement('div');
      row.classList.add('logos-row');

      group.forEach((logo) => row.appendChild(logo));
      wrapper.appendChild(row);
    }

    // Clone
    const rows = wrapper.querySelectorAll('.logos-row');
    const rowCount = rows.length;
    const rowHeight = rows[0].offsetHeight;

    const firstClone = rows[0].cloneNode(true);
    wrapper.appendChild(firstClone);

    let index = 0;
    const slideDuration = 800;
    const pauseDuration = 2000;

    function slideRows() {
      index++;
      wrapper.style.transition = `transform ${slideDuration}ms ease`;
      wrapper.style.transform = `translateY(-${index * rowHeight}px)`;

      if (index === rowCount) {
        setTimeout(() => {
          wrapper.style.transition = 'none';
          wrapper.style.transform = 'translateY(0)';
          index = 0;
        }, slideDuration);
      }
    }

    setInterval(slideRows, slideDuration + pauseDuration);
    });
  }

  // Dynamic panel handler
  function initDynamicPanel() {
    const nav = document.querySelector('.horizontal-nav');
    if (!nav) return;

    const buttons = nav.querySelectorAll('.horizontal-nav__item');
    const mode = nav.dataset.mode;

    if (!buttons.length) return;

    function activateButton(button) {
      buttons.forEach(b => b.classList.remove('active'));
      button.classList.add('active');

      // Dynamic panel logic
      if (mode === 'switch') {
        const tagTitle = button.dataset.tagTitle;
        const title = button.dataset.title;
        const desc = button.dataset.desc;
        const media = button.dataset.media;
        const alt = button.dataset.alt;
        const link = button.dataset.link;
        const linkLabel = button.dataset.linkLabel;

        const tagTitleEl = document.querySelector('.dynamic-panel__tag-title');
        const titleEl = document.querySelector('.data-content__title');
        const descEl = document.querySelector('.data-content__desc');
        const linkEl = document.querySelector('.data-content__link');
        const mediaContainer = document.getElementById('media-display');
        const mediaWrapper = document.querySelector('.dynamic-panel__media')
        const contentWrapper = document.querySelector('.dynamic-panel__left');
        const labelSpan = linkEl.querySelector('.data-content__link-label');
        const muteWrapper = document.querySelector('.mute-icon-wrapper');
        const muteIcon = muteWrapper.querySelector('.icon-mute');
        const unmuteIcon = muteWrapper.querySelector('.icon-unmute');

        if (tagTitleEl) tagTitleEl.textContent = tagTitle || '';
        if (titleEl) titleEl.textContent = title || '';
        if (descEl) descEl.textContent = desc || '';
        if (linkEl) linkEl.href = link || '#';
        if (labelSpan) labelSpan.textContent = linkLabel || '';

        const children = Array.from(mediaContainer.children).filter(el => el !== muteWrapper);
        children.forEach(el => el.remove());

        contentWrapper?.classList.add('is-fading');
        mediaWrapper?.classList.add('is-fading');

        setTimeout(() => {
          setTimeout(() => {
            contentWrapper?.classList.remove('is-fading');
            mediaWrapper?.classList.remove('is-fading');
          }, 50);
        }, 100);

        setTimeout(() => {
          if (media && media.match(/\.(mp4|mov|webm|ogg)$/i)) {
            const video = document.createElement('video');
            video.autoplay = true;
            video.loop = true;
            video.muted = true;
            video.defaultMuted = true;
            video.playsInline = true;
            video.setAttribute('aria-label', alt);

            const source = document.createElement('source');
            source.src = media;
            video.appendChild(source);
            mediaContainer.appendChild(video);

            if (muteWrapper && muteIcon && unmuteIcon) {
              muteWrapper.hidden = false;
              muteIcon.hidden = false;
              unmuteIcon.hidden = true;

              muteWrapper.onclick = () => {
                video.muted = !video.muted;
                muteIcon.hidden = !video.muted;
                unmuteIcon.hidden = video.muted;
              };
            }
          } else {
            const img = document.createElement('img');
            img.src = media;
            img.alt = alt;
            mediaContainer.appendChild(img);

            if (muteWrapper) muteWrapper.hidden = true;
          }

          contentWrapper?.classList.add('in');
        }, 100);
      }

      // Positions logic
      if (mode === 'filter') {
        const value = button.dataset.value;
        const items = document.querySelectorAll('.positions-list__item');

        items.forEach(item => {
          const country = item.dataset.country;
          const shouldShow = value === 'all' || country === value;
          item.style.display = shouldShow ? 'flex' : 'none';
        });
      }
    }

    buttons.forEach(btn => {
      btn.addEventListener('click', () => activateButton(btn));
    });

    activateButton(buttons[0]);
  }

  // Logic for MediaTabComponent
  function initHorizontalScroll() {
    document.querySelectorAll('.horizontal-nav__item').forEach(slide => {
      slide.addEventListener('click', () => {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });
  }

  function enableMouseWheelHorizontalScroll(containerSelector = '.horizontal-nav__list') {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    container.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        e.preventDefault();
        container.scrollBy({
          left: e.deltaY,
          behavior: 'smooth'
        });
      }
    }, { passive: false });
  }
  // 

  // Unmute video 
  function enableSound() {
    const video = document.querySelector('[data-video]');
    const muteIcon = document.querySelector('[data-mute-toggle]');
    const iconMute = muteIcon?.querySelector('[data-icon-state="mute"]');
    const iconUnmute = muteIcon?.querySelector('[data-icon-state="unmute"]');

    if (!video || !muteIcon || !iconMute || !iconUnmute) return;

    if (!muteIcon.dataset.listenerAdded) {
      muteIcon.addEventListener("click", function () {
        video.muted = !video.muted;
        iconMute.hidden = !video.muted;
        iconUnmute.hidden = video.muted;
      });
      muteIcon.dataset.listenerAdded = "true";
    }
  }

  initErrorPageTitleAnimation();
  initLogoWall();
  initDynamicPanel();
  initHorizontalScroll();
  enableMouseWheelHorizontalScroll();
  enableSound();
});